import Body from 'commons/card/Body';
import { default as Card } from 'commons/card/CollapsableCard';
import Header from 'commons/card/Header';
import LoadingCard from 'commons/card/LoadingCard';
import React from 'react';
import { useLocation } from 'react-router-dom';
import MessageDate from './MessageDate';
import MessageDetail from './MessageDetail';
import MessageProduits from './MessageProduits';
import MessageDocuments from './MessageDocuments';
import { useGetAnnoncesQuery } from '../../../redux/api/cache';

export default function MessageInfo() {
  const location = useLocation();
  const { data: annonces = {}, isLoading } = useGetAnnoncesQuery({ ann_num: location.pathname.split('Numero=')[1] });

  return (
    <div>
      {!isLoading && annonces.data && annonces.data.length === 0 && (
        <Card key={Math.random() + 'card'} canCollapse={false}>
          <Header title={'Oups'}></Header>
          {!isLoading && (
            <Body>
              <label> Il n'y a aucune annonce associé à cet identifiant </label>
            </Body>
          )}
        </Card>
      )}
      {!isLoading && annonces.data && annonces.data.length !== 0 && (
        <div>
          <MessageDetail data={location.state} />
          <div>
            <MessageDate data={annonces.data[0]} />
            <MessageProduits data={annonces.data[0]} />
            <MessageDocuments data={annonces.data[0]} />
          </div>
        </div>
      )}
      {isLoading && <LoadingCard title="Annonce" />}
    </div>
  );
}
